<!-- begin::Brand -->
<div class="aside-logo flex-column-auto" id="kt_aside_logo">
  <ng-container *ngIf="asideTheme === 'dark'">
    <a [routerLink]="homeRedirectRoute$|async">
      <ng-container *ngIf="asideMinimize">
        <img
          alt="Logo"
          class="h-25px logo-minimize"
          src="./assets/media/logos/adshero_blue_small.svg"
        />
      </ng-container>
      <img
        alt="Logo"
        class="h-25px logo"
        src="./assets/media/logos/adshero_blue.svg"
      />
    </a>
  </ng-container>

  <ng-container *ngIf="asideTheme === 'light'">
    <ng-container *ngIf="asideMinimize">
      <app-logo
        [isSmall]="true"
        class="logo-minimize ms-n5"
      ></app-logo>
    </ng-container>
    <app-logo
      [isSmall]="false"
      class="logo"
    ></app-logo>
  </ng-container>
</div>
<!-- end::Brand  -->

<!-- begin::Aside menu -->
<div class="aside-menu flex-column-fluid mt-4 mt-lg-2">
  <div
    #ktAsideScroll
    id="kt_aside_menu_wrapper"
    class="hover-scroll-overlay-y mb-5 mb-lg-5"
    data-kt-scroll="true"
    data-kt-scroll-activate="{default: false, lg: true}"
    data-kt-scroll-height="auto"
    data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
    data-kt-scroll-wrappers="#kt_aside_menu"
    data-kt-scroll-offset="0"
  >
    <div
      *ngIf="showAccountsDropdown$ | async"
      class="aside__account-switcher d-flex align-items-center"
    >
      <app-account-trigger
        #kt_account_menu
        class="position-relative w-100"
        data-kt-menu-trigger="click"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-end"
        data-kt-menu-flip="bottom"
      >
        {{(account$ | async)?.name || ("MENU.SELECT_ACCOUNT" | translate)}}
        <app-overlay-loader *ngIf="(account$ | async) === null"></app-overlay-loader>
      </app-account-trigger>
      <app-notifications-inner [triggerRef]="ktAccountMenu"></app-notifications-inner>
    </div>
    <div
      id="#kt_aside_menu"
      data-kt-menu="true"
      class="
        menu
        menu-column
        menu-gray-900
        menu-state-title-primary
        menu-state-icon-primary
        menu-state-bullet-primary
      "
    >
      <app-aside-menu id="asideMenu"></app-aside-menu>
    </div>
  </div>
</div>
<!-- end::Aside menu -->

<!-- begin::Footer -->
<div class="aside-footer flex-column-auto pt-5 pb-7 px-5" id="kt_aside_footer">
  <app-patron *ngIf="patronAclService.canSeePatron$ | async"></app-patron>

  <!-- begin::Aside toggle -->
  <ng-container *ngIf="asideMinimize">
    <div
      id="kt_aside_toggle"
      class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
      data-kt-toggle="true"
      data-kt-toggle-state="active"
      data-kt-toggle-target="body"
      data-kt-toggle-name="aside-minimize"
    >
      <span
        [inlineSVG]="'./assets/media/icons/duotune/arrows/arr079.svg'"
        class="svg-icon svg-icon-1 rotate-180"
      >
      </span>
      <span class="aside-toggle__text ps-3 text-nowrap">{{ 'MENU.TOGGLE_MENU' | translate }}</span>
    </div>
  </ng-container>
  <!-- end::Aside toggler -->
</div>
<!-- end::Footer -->
